import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { BuildingType } from "@app/shared/components/building/data";

@Component({
    selector: "app-icon",
    templateUrl: "./icon.component.html",
    styleUrl: "./icon.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent {
  public size = input<number>(50);
  public type = input<BuildingType>(BuildingType.Tracker);
  public buildingType = BuildingType;
}
